import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {
  areCompetitorResultsEqual,
  CategoryType,
  CompetitorResults,
  EventItem,
  Lookups,
  Race,
  RaceSettings
} from "@model";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ResultsDetailsModalComponent} from "../results-details-modal/results-details-modal.component";
import {AbstractComponent} from "../abstract.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-live-results-table-body',
  templateUrl: './live-results-table-body.component.html',
  styleUrls: ['./live-results-table-body.component.scss'],
  animations: [
    trigger('animate', [
      state('*', style({transform: 'scaleY(1)', opacity: 1})),

      transition('void => *', [
        style({transform: 'translateY(100%)', opacity: 0}),
        animate(500),
      ]),
    ]),
  ],
})
export class LiveResultsTableBodyComponent extends AbstractComponent implements OnChanges {

  @Input() competitorLiveResults: CompetitorResults[] = [];
  @Input() race: Race | undefined;
  @Input() event: EventItem | undefined = undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isRoundRace?: boolean;
  @Input() measurementType: number | undefined = undefined;
  @Input() gender?: number;
  @Input() category?: number;
  @Input() raceSettings: RaceSettings | undefined
  @Input() isFullScreen: boolean = false;
  @Input() isFinished: boolean = false;

  previousIndexes: Map<number, { index: number }> = new Map();
  firstCompetitorResults: CompetitorResults | undefined = undefined;
  tableData: LiveResultTableRowData[] = [];
  fireAnimate: boolean = false;
  showCategories: boolean = false;


  constructor(private modalService: NgbModal) {
    super();
  }

  ngOnInit(): void {
    this.showCategories = !!this.raceSettings?.category?.categoryType && (this.raceSettings?.category?.categoryType !== CategoryType.NOT_USED);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['competitorLiveResults']?.currentValue) return;
    this.handleCompetitorResultsChange(changes['competitorLiveResults'].previousValue ?? [], changes['competitorLiveResults'].currentValue)
  }

  handleCompetitorResultsChange(previous: CompetitorResults[], current: CompetitorResults[]) {
    const newTableData: LiveResultTableRowData[] = [];

    current.forEach((result, index) => {
      const rowData = new LiveResultTableRowData(0, false, result.id, result);
      const prevIndex = this.previousIndexes.get(result.id!)?.index;
      if (prevIndex !== undefined && this.tableData[prevIndex]) {
        const prevResult = previous[prevIndex];

        if (!areCompetitorResultsEqual(prevResult, result)) {
          this.tableData[prevIndex].updated = true;
        }

        if (prevIndex !== index) {
          this.tableData[prevIndex].delta = (index - prevIndex) * 100;
        }
      }

      this.previousIndexes.set(result.id!, {index});
      newTableData.push(rowData);
    });

    this.fireAnimate = true;
    setTimeout(() => {
      this.fireAnimate = false;
      this.tableData = [...newTableData];
      this.firstCompetitorResults = this.tableData[0]?.competitorResults ?? undefined;
    }, 500);
  }

  openDetailsModal(competitorResults: CompetitorResults | undefined, isMobile: boolean = false): void {
    if (competitorResults) {
      const modalRef = this.modalService.open(ResultsDetailsModalComponent, {
        centered: true,
        windowClass: isMobile ? 'results-details-modal modal-mobile' : 'results-details-modal',
      });
      modalRef.componentInstance.competitorResults = competitorResults;
      modalRef.componentInstance.firstCompetitorResults = this.firstCompetitorResults;
      modalRef.componentInstance.measurementType = this.measurementType;
      modalRef.componentInstance.category = this.category;
      modalRef.componentInstance.gender = this.gender;
      modalRef.componentInstance.isRoundRace = this.isRoundRace;
      modalRef.componentInstance.race = this.race;
      modalRef.componentInstance.event = this.event;
      modalRef.componentInstance.languages = this.languages;
      modalRef.componentInstance.isAdmin = false;
    }
  }
}



export class LiveResultTableRowData {
  constructor(public delta?: number, public updated?: boolean, public id?: number, public competitorResults?: CompetitorResults) { }
}

